/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-29 11:27:25
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-07-18 16:39:37
 */
import config from "../config/config";
export const addJS = (url, id) => {
    return new Promise((resolve) => {
        const scriptObj = document.getElementById(id);
        if (scriptObj != null) {
            resolve({});
        }
        else {
            const scriptDom = document.createElement("script");
            scriptDom.id = id;
            scriptDom.type = "text/javascript";
            scriptDom.src = url;
            document.head.appendChild(scriptDom);
            scriptDom.onload = function () {
                resolve({});
            };
        }
    });
};
export const echartsJS = () => {
    // 图表
    const url = "./common/echarts.min.js";
    return addJS(url, "echartsJS");
};
export const addQrcodeJs = () => {
    // 二维码
    const url = "./common/qrcode.min.js";
    return addJS(url, "addQrcodeJs");
};
export const gaodeMapJS = () => {
    // 高德地图
    const url = "https://webapi.amap.com/maps?v=2.0&key=" +
        config.mapKeyApi +
        "&plugin=AMap.Autocomplete,AMap.PlaceSearch,AMap.MarkerCluster,AMap.Geolocation";
    return addJS(url, "gaodeMapJS");
};
